/* DillySocks — Scroll-Depth-Bruecke (UX-Audit F002, Sean 31.08.2026).

   Horizon scrollt ab Desktop-Breite im .page-wrapper-Container statt im
   Window (bewusste Theme-Architektur, siehe base.css). GA4s "Scroll"-
   Enhanced-Measurement und GTM-Scroll-Trigger hoeren aber aufs Window und
   sind auf Desktop deshalb blind. Diese Bruecke misst den tatsaechlichen
   Scroller und pusht die ueblichen Schwellen in den dataLayer:

     { event: 'ds_scroll_depth', scroll_percent: 25|50|75|90 }

   Jede Schwelle feuert genau einmal pro Seitenaufruf. Scrollt das Window
   selbst (Mobile), misst die Bruecke dieses — so gibt es EINE Quelle fuer
   alle Viewports und GTM kann den nativen Scroll-Trigger ignorieren. */
(function () {
  'use strict';

  var THRESHOLDS = [25, 50, 75, 90];
  var fired = {};

  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 10) return pw;
    return null; // Window-Scrolling (Mobile)
  }

  function measure() {
    var el = scroller();
    var top, visible, total;
    if (el) {
      top = el.scrollTop;
      visible = el.clientHeight;
      total = el.scrollHeight;
    } else {
      top = window.scrollY || document.documentElement.scrollTop || 0;
      visible = window.innerHeight;
      total = document.documentElement.scrollHeight;
    }
    if (total <= visible) return 100;
    return Math.round(((top + visible) / total) * 100);
  }

  function check() {
    var pct = measure();
    for (var i = 0; i < THRESHOLDS.length; i++) {
      var t = THRESHOLDS[i];
      if (pct >= t && !fired[t]) {
        fired[t] = true;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'ds_scroll_depth', scroll_percent: t });
      }
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      check();
    });
  }

  function init() {
    /* Capture am Document faengt Scroll-Events JEDES Containers (scroll
       bubbelt nicht) — immun gegen spaete Layout-Wechsel zwischen Window-
       und Wrapper-Scrolling (z.B. Resize ueber die 990px-Grenze). */
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    /* Kurze Seiten: 90 % koennen schon beim Laden erreicht sein. */
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
